<template lang="html">
  <div class="alignCenter">
    <div class="col-sm-4 paddingNone">
      <select :disabled="selectDisabled" id="inputState" class="form-control" v-model="y">
        <option v-for="item in year" :value="item">{{ item }}</option>
      </select>
    </div>
    <div class="col-sm-1 paddingNone">
      <span>年</span>
    </div>
    <div class="col-sm-3 paddingNone">
      <select :disabled="selectDisabled" id="inputState" class="form-control" v-model="m">
        <option v-for="item in month" :value="item">{{ formatTime(item) }}</option>
      </select>
    </div>
    <div class="col-sm-1 paddingNone">
      <span>月</span>
    </div>
    <div class="col-sm-3 paddingNone">
      <select :disabled="selectDisabled" id="inputState" class="form-control" v-model="d">
        <option selected value="">日</option>
        <option v-for="item in day" :value="item" @click="">{{ formatTime(item) }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: ['default', 'disabled'],
  data() {
    return {
      year: [],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      day: [],
      y: '',
      m: '1',
      d: '1',
      selectDisabled: false
    }
  },

  methods: {
    formatTime(date) {
      let time = date + '';
      return time.length == 2 ? time : '0' + time
    },
    getFullDay() {
      let fullDay = new Date(this.y, this.m, 0).getDate()
      this.day = []
      for (let i = 1; i <= fullDay; i++) {
        this.day.push(i)
      }
      if (this.day.indexOf(this.d) == -1) {
        this.d = 1
      }
      let birthdate = `${this.y}-${this.formatTime(this.m)}-${this.formatTime(this.d)}`
      this.$emit('getBirthdate', { birthdate: birthdate })
    },
    valueTime(time) {
      if (time.indexOf('0') == 0) {
        time = time.substr(1, 1)
      }
      return time
    },
    setTime(year, month, day) {
      if (month[0] == '0') {
        month = month.replace('0', '')
      }
      if (day[0] == '0') {
        day = day.replace('0', '')
      }
      this.y = Number(year);
      this.m = Number(month);
      this.d = Number(day);
      this.getFullDay()
    }
  },
  mounted() {
    let date = new Date()
    let currentYear = date.getFullYear()
    console.log(currentYear)
    for (let i = currentYear - 90; i <= currentYear; i++) {
      this.year.push(i)
    }
    if (this.disabled) {
      this.selectDisabled = true;
    }
    if (this.default) {
      let dateArr = this.default.split('-')
      console.log(dateArr, "----")
      this.y = dateArr[0]
      this.m = this.valueTime(dateArr[1])
      this.d = this.valueTime(dateArr[2])
    } else {
      this.y = currentYear
    }

    this.getFullDay()
  },
  watch: {
    y(val) {
      this.getFullDay()
    },
    m(val) {
      this.getFullDay()
    },
    d(val) {
      this.getFullDay()
    }
  }
}
</script>

<style lang="css" scoped>
.paddingNone {
  padding: 0;
  margin-right: 0px;
  font-size: 13px;
}

.paddingNone span {
  display: inline-block;
}

select {
  font-size: 13px;
  padding-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/birthdate.vue